/**
 * @generated SignedSource<<b33ee150cab48493ab59e79dfb9f55a5>>
 * @relayHash 3550630b2f965754bce8bf602aaa1924
 * @lightSyntaxTransform
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3550630b2f965754bce8bf602aaa1924

import { ConcreteRequest } from 'relay-runtime';
export type PatientRecordExportStatus = "COMPLETED" | "DELIVERING" | "DISCARDED" | "FAILED" | "GENERATING_SUMMARY" | "PACKAGING" | "SUMMARY_READY";
export type Ch_confirmPatientRecordExportInput = {
  requestId: string;
};
export type useConfirmPatientRecordExportMutation$variables = {
  input: Ch_confirmPatientRecordExportInput;
};
export type useConfirmPatientRecordExportMutation$data = {
  readonly ch_confirmPatientRecordExport: {
    readonly confirmPatientRecordExportOutput: {
      readonly requestId: string;
      readonly status: PatientRecordExportStatus;
    } | null;
  };
};
export type useConfirmPatientRecordExportMutation = {
  response: useConfirmPatientRecordExportMutation$data;
  variables: useConfirmPatientRecordExportMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "Ch_confirmPatientRecordExportPayload",
    "kind": "LinkedField",
    "name": "ch_confirmPatientRecordExport",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ConfirmPatientRecordExportOutput",
        "kind": "LinkedField",
        "name": "confirmPatientRecordExportOutput",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "requestId",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "status",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "useConfirmPatientRecordExportMutation",
    "selections": (v1/*:: as any*/),
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*:: as any*/),
    "kind": "Operation",
    "name": "useConfirmPatientRecordExportMutation",
    "selections": (v1/*:: as any*/)
  },
  "params": {
    "id": "3550630b2f965754bce8bf602aaa1924",
    "metadata": {},
    "name": "useConfirmPatientRecordExportMutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "4212c41374c427bd7d3e4d17430e2ae9";

export default node;
